import { memo } from 'react';

import { FileStatusIconErrored, FileStatusSubtitle, FileStatusTitle } from '@air/feature-file-status/ui';

import { type CaptionVideoTaskMetadata } from '~/components/CaptionVideoTasks/types';
import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneDismissButton } from '~/components/FileStatusTrackingPane/TaskPaneDismissButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type CaptionVideoTaskPanelItemFailedProps = {
  metadata: CaptionVideoTaskMetadata;
  onClear: () => void;
};

const getCaptionFailedSubtitle = (isAssetVersion: boolean) =>
  isAssetVersion
    ? 'Unable to save captions as new version. Please try again.'
    : 'Unable to save captions as new asset. Please try again.';

export const CaptionVideoTaskPanelItemFailed = memo(({ metadata, onClear }: CaptionVideoTaskPanelItemFailedProps) => {
  const { ui2026 } = useTemporaryFeatureFlags();
  const isAssetVersion = metadata.saveResultAs?.as === 'assetVersion';

  return (
    <PaneItemTW
      avatar={<FileStatusIconErrored size={getTaskPaneFileStatusIconSize(ui2026)} />}
      title={
        <FileStatusTitle data-testid="CAPTION_VIDEO_PANEL_FAILED_TITLE">
          {ui2026 ? 'Couldn’t save captions' : 'Error saving captions'}
        </FileStatusTitle>
      }
      subtitle={
        ui2026 ? undefined : (
          <FileStatusSubtitle className="truncate">{getCaptionFailedSubtitle(isAssetVersion)}</FileStatusSubtitle>
        )
      }
      buttons={<TaskPaneDismissButton label="Dismiss" onClick={onClear} />}
    />
  );
});

CaptionVideoTaskPanelItemFailed.displayName = 'CaptionVideoTaskPanelItemFailed';
